import { gql } from '@apollo/client'

export const GET_INTERNAL_NOTES = gql`
  query GetInternalNotes($category_notes: [String!], $document_id: Int) {
    getInternalNotes(
      category_notes: $category_notes
      document_id: $document_id
    ) {
      id
      category_note
      document_id
      user_id
      text
      file_id
      type
      internal
      InternalNotesToUser {
        id
        name
        charge
        id_role
        type_user
        JobPositionOfUser {
          id
          name
        }
      }
      fileInternal {
        id
        url
      }
      createdAt
      status_id
      InternalNotesToStatus {
        name
        description
        progress
        color
        order
      }
    }
  }
`

export const CREATE_INTERNAL_NOTE = gql`
  mutation CreateInternalNote($inputInternalNote: internalNote!) {
    createInternalNote(inputInternalNote: $inputInternalNote)
  }
`

export const NOTIFY_INTERNAL_NOTES_SUBSCRIPTION = gql`
  subscription NotifyInternalNotesSuscription {
    notifyInternalNotesSuscription {
      document_id
    }
  }
`
//REQUESTS

export const GET_INTERNAL_NOTES_REQUEST = gql`
  query GetInternalNotesRequest($categoryNotes: [String!], $requestId: Int) {
    getInternalNotesRequest(
      category_notes: $categoryNotes
      request_id: $requestId
    ) {
      id
      category_note
      request_id
      user_id
      text
      file_id
      type
      internal
      createdAt
      InternalNotesToUser {
        id
        name
      }
      fileInternalRequest {
        id
        url
      }
    }
  }
`

export const CREATE_INTERNAL_NOTE_REQUEST = gql`
  mutation CreateInternalNoteRequest($input: internalNoteRequest!) {
    createInternalNoteRequest(input: $input)
  }
`

export const EDIT_INTERNAL_NOTE = gql`
  mutation UpdateInternalNote($id: Int!, $inputEditMessage: editMessage!) {
    updateInternalNote(id: $id, inputEditMessage: $inputEditMessage)
  }
`

export const DELETE_INTERNAL_NOTE = gql`
  mutation DeleteInternalNote($id: Int!) {
    deleteInternalNote(id: $id)
  }
`
